"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstrumentOpenTimes = exports.isInstrumentOpen = void 0;
const luxon_1 = require("luxon");
const MS_IN_WEEK = 604800000;
const isInstrumentOpen = (dateTime, times) => {
    const dateTimeWeekMillis = dateTime.toMillis() % MS_IN_WEEK;
    return times.some((t) => (t.open < t.close && dateTimeWeekMillis >= t.open && dateTimeWeekMillis < t.close) ||
        (t.open > t.close && (dateTimeWeekMillis >= t.open || dateTimeWeekMillis < t.close)));
};
exports.isInstrumentOpen = isInstrumentOpen;
// Convert open time to day index (Monday = 1, Sunday = 7)
const getDayIndex = (millis) => ((Math.floor(millis / (24 * 60 * 60 * 1000)) + 4) % 7) + 1;
const getInstrumentOpenTimes = (times) => {
    let openTimes = [];
    // Sort times by day index
    const sortedTimes = [...times].sort((a, b) => getDayIndex(a.open) - getDayIndex(b.open));
    sortedTimes.forEach((time) => {
        const day = getDayIndex(time.open);
        const open = luxon_1.DateTime.fromMillis(time.open);
        const close = luxon_1.DateTime.fromMillis(time.close);
        // Check if last entry has the same open/close times
        const lastEntry = openTimes[openTimes.length - 1];
        if (lastEntry &&
            lastEntry.open.hour === open.hour &&
            lastEntry.open.minute === open.minute &&
            lastEntry.open.second === open.second &&
            lastEntry.close.hour === close.hour &&
            lastEntry.close.minute === close.minute &&
            lastEntry.close.second === close.second) {
            lastEntry.to = day;
        }
        else {
            openTimes.push({ from: day, to: day, open, close });
        }
    });
    return openTimes.sort((a, b) => a.from - b.from);
};
exports.getInstrumentOpenTimes = getInstrumentOpenTimes;
//# sourceMappingURL=instrumentTimes.js.map